const FULLNAME = '';
const PROFILE = '';
const ROLE_ID = '';
const ID = 0;
const TOKEN = '';
const DOMAINE = false;
const CONTRIBUTOR = false;
const CONFIG = null;

var UserProfile = (function() {
    var fullName = FULLNAME;
    var profile = PROFILE;
    var roleId = ROLE_ID;
    var id = ID;
    var token = TOKEN;
    var domaine = DOMAINE;
    var contributor = CONTRIBUTOR;
    var config = CONFIG;

    var getConfig = function() {
        return JSON.parse(localStorage.getItem('config'));
    };

    var getId = function() {
        return localStorage.getItem('id');
    };

    var getName = function() {
        return localStorage.getItem('name');
    };

    var getToken = function() {
        return localStorage.getItem('token');
    };

    var getContributor = function() {
        return JSON.parse(localStorage.getItem('contributor'));
    };

    var getProfile = function() {
        return localStorage.getItem('profile');
    };

    var getRoleId = function() {
        return localStorage.getItem('roleId');
    };

    var getDomaine = function() {
        return JSON.parse(localStorage.getItem('domaine'));
    };

    var setConfig = function(_config) {
        config = _config;
        localStorage.setItem('config', _config);
    };

    var setId = function(_id) {
        id = _id;
        localStorage.setItem('id', id);
    };

    var setName = function(name) {
        fullName = name;
        localStorage.setItem('name', name);
    };

    var setToken = function(_token) {
        token = _token;
        localStorage.setItem('token', token);
    };

    var setProfile = function(_profile) {
        profile = _profile;
        localStorage.setItem('profile', _profile);
    };

    var setContributor = function(_contributor) {
        contributor = _contributor;
        localStorage.setItem('contributor', _contributor);
    };

    var setRoleId = function(_roleId) {
        roleId = _roleId;
        localStorage.setItem('roleId', _roleId);
    };

    var setDomaine = function(_domaine) {
        domaine = _domaine;
        localStorage.setItem('domaine', _domaine);
    };

    var setSession = function() {
        localStorage.setItem('id', getId());
        localStorage.setItem('name', getName());
        localStorage.setItem('token', getToken());
        localStorage.setItem('profile', getProfile());
        localStorage.setItem('domaine', getDomaine());
        localStorage.setItem('contributor', getContributor());
        localStorage.setItem('config', JSON.stringify(getConfig()));
    };

    var clearSession = function() {
        localStorage.setItem('id', ID);
        localStorage.setItem('name', FULLNAME);
        localStorage.setItem('token', TOKEN);
        localStorage.setItem('profile', PROFILE);
        localStorage.setItem('domaine', DOMAINE);
        localStorage.setItem('contributor', CONTRIBUTOR);
        localStorage.setItem('config', CONFIG);
    };

    var getSessionStorage = function() {
        return {
            name: getName(),
            profile: getProfile()
        };
    };

    return {
        getId: getId,
        setId: setId,
        getToken: getToken,
        setToken: setToken,
        getContributor: getContributor,
        setContributor: setContributor,
        getName: getName,
        setName: setName,
        getProfile: getProfile,
        setProfile: setProfile,
        getRoleId: getRoleId,
        setRoleId: setRoleId,
        getDomaine: getDomaine,
        setDomaine: setDomaine,
        setSession: setSession,
        clearSession: clearSession,
        getSessionStorage: getSessionStorage,
        setConfig: setConfig,
        getConfig: getConfig
    };
})();

export default UserProfile;
